<template>
  <div class="gw-vacio">
    <div class="gw-vacio-marca">
      <span class="gw-vacio-icono">◷</span>
    </div>

    <h3 class="gw-vacio-titulo">{{ titulo }}</h3>
    <p class="gw-vacio-texto">{{ texto }}</p>

    <div class="gw-vacio-previo">
      <div class="gw-vacio-previo-titulo">Esto es lo que verás aquí</div>
      <ul>
        <li v-for="item in previo" :key="item.titulo">
          <b>{{ item.titulo }}.</b> {{ item.detalle }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import slaFormat from "../../mixins/slaFormat";

export default {
  name: "SlaEmptyState",
  mixins: [slaFormat],
  props: {
    // 'sin_medicion' = la medición todavía no empieza; el cliente solo espera.
    // 'sin_datos'    = no hay procesos en este rango; el cliente puede actuar.
    motivo: { type: String, required: true },
    medicionDesde: { type: String, default: null },
    desde: { type: String, default: null },
    hasta: { type: String, default: null },
  },

  computed: {
    titulo() {
      return this.motivo === "sin_medicion"
        ? "La medición de tiempos empieza el " + this.fechaLegible(this.medicionDesde)
        : "No hay procesos en este rango de fechas";
    },

    texto() {
      if (this.motivo === "sin_medicion") {
        return (
          "A partir de esa fecha, cada validación de tus procesos se mide en " +
          "horas hábiles y sus resultados se muestran en esta pestaña. No se " +
          "presenta un histórico anterior porque no existe medición para ese " +
          "periodo."
        );
      }
      return (
        "No hay procesos registrados entre el " + this.fechaLegible(this.desde) +
        " y el " + this.fechaLegible(this.hasta) +
        ". Selecciona otro rango de fechas."
      );
    },

    previo() {
      return [
        {
          titulo: "Cumplimiento de ANS",
          detalle: "porcentaje de procesos resueltos dentro del plazo acordado y su evolución semanal.",
        },
        {
          titulo: "De quién fue el tiempo",
          detalle: "distribución del tiempo según el responsable de cada tramo.",
        },
        {
          titulo: "Dónde se atascan los procesos",
          detalle: "tiempo acumulado en cada tipo de validación.",
        },
        {
          titulo: "Top motivos de demora",
          detalle: "motivos de espera registrados, ordenados por el tiempo que representan.",
        },
        {
          titulo: "Cumplimiento por validación",
          detalle: "tiempos de resolución por validación, con mediana y percentil 90.",
        },
      ];
    },
  },
};
</script>

<style scoped>
.gw-vacio {
  max-width: 620px;
  margin: 20px auto 28px;
  padding: 36px 32px;
  text-align: center;
  background: #fbf9fd;
  border: 1px solid rgba(95, 0, 145, 0.1);
  border-radius: 14px;
}
.gw-vacio-marca {
  width: 54px;
  height: 54px;
  margin: 0 auto 18px;
  border-radius: 50%;
  background: rgba(95, 0, 145, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
}
.gw-vacio-icono {
  font-size: 26px;
  color: #5f0091;
  line-height: 1;
}
.gw-vacio-titulo {
  font-size: 18px;
  font-weight: 700;
  color: #3b3b3b;
  margin: 0 0 10px;
}
.gw-vacio-texto {
  font-size: 13px;
  line-height: 1.6;
  color: #6b6b6b;
  margin: 0 auto;
  max-width: 54ch;
}
.gw-vacio-previo {
  margin-top: 26px;
  padding-top: 20px;
  border-top: 1px solid rgba(95, 0, 145, 0.1);
  text-align: left;
}
.gw-vacio-previo-titulo {
  font-size: 11px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #9a9a9a;
  margin-bottom: 10px;
}
.gw-vacio-previo ul {
  margin: 0;
  padding-left: 18px;
}
.gw-vacio-previo li {
  font-size: 12.5px;
  line-height: 1.65;
  color: #6b6b6b;
  margin-bottom: 7px;
}
.gw-vacio-previo b {
  color: #3b3b3b;
  font-weight: 600;
}
</style>
